module.exports = __webpack_public_path__ + "static/media/in_progress.1cee7ac2.png";